import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SimpleReactValidator from 'simple-react-validator';
import {submitFormData} from '../../actions/registrationForms'
import { toast } from 'react-toastify';


class regEnquery extends Component {
    constructor() {
        super()
        this.state = {
            war_frame_number: '',
            war_name: '',
            war_mail: '',
            war_address: '',
            war_store_name: '',
            war_city: '',
            war_purchase_date: '',
            war_invoice_copy: ''
        }
        this.validator = new SimpleReactValidator();
        this.handleSubmit= this.handleSubmit.bind(this)
    }
    handleSubmit = (event) => {

        event.preventDefault();
        if (this.validator.allValid()) {

            
            const { connection_id } = this.props
            const options = {
               connection_id:connection_id,
               name:this.state.war_name,
               email:this.state.war_mail,
               city:this.state.war_city,
               state:'',
               subject:'',
               message:''
            }
   
           this.props.submitFormData(options)
       
           setTimeout(()=>{
               
                //   this.props.history.goBack()
               
           }, 500);

        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleChange(event) {
      
        this.setState({ [event.target.id]: event.target.value });
    }
    render() {        
        return (
            <div>
                <div className="breadcrumb-section" style={{
                    background: 'var(--theme-color)',
                    color: 'white'
                }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="page-title" style={{ display: 'block', textAlignLast: 'center' }}>
                                    <div style={{ fontSize: 15, padding: 5 }}>Home</div>
                                    <h2 style={{ fontSize: 22, color: 'white' }} >Registration</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section>
                    <div className='container enquery-form'>

                        <form onSubmit={(event) => this.handleSubmit(event)}>
                           <div className='row'>
                                <div className='col-md-12'>
                                    <div style={{padding:10}}> <label>Enter Bike Frame Number*</label>
                                    <input type='text' style={{ width: '100%', height: 35 }} id='war_frame_number' onChange={(e) => this.handleChange(e)} />
                                    {/* {this.validator.message('Frame Number', this.state.war_frame_number, 'required|number')} */}
                                   </div></div>
                                <div className='col-md-6'>

                                    <div style={{padding:'10px 10px 0px 10px'}}><h5>Address and Contact Info</h5></div>
                                    <div style={{padding:10}}>
                                        <label>Name*</label>
                                        <input type='text' style={{ width: '100%', height: 35 }} id='war_name' onChange={(e) => this.handleChange(e)} />
                                        {/* {this.validator.message('Name', this.state.war_name, 'required|alpha_space')} */}
                                    </div>

                                    <div style={{padding:10}}>
                                        <label>Email*</label>
                                        <input type='text' style={{ width: '100%', height: 35 }} id='war_mail' onChange={(e) => this.handleChange(e)} />
                                        {/* {this.validator.message('Mail', this.state.war_mail, 'required|email')} */}
                                    </div>
                                    <div style={{padding:10}}>
                                        <label>Address*</label>
                                        <textarea id='war_address' style={{ width: '100%', height: 100 }} onChange={(e) => this.handleChange(e)} ></textarea>
                                         {/* {this.validator.message('Address', this.state.war_address, 'required|alpha_num_dash_space')} */}
                                    </div>
                                    <div style={{padding:10}}>
                                        <label>Mobile*</label>
                                        <input type='text' style={{ width: '100%', height: 35 }} id='war_mobile' onChange={(e) => this.handleChange(e)} />
                                        {/* {this.validator.message('Mobile', this.state.war_mobile, 'required|phone')} */}
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div style={{padding:'10px 10px 0px 10px'}}><h5>Point of Purchase</h5></div>
                                    <div style={{padding:10}}>
                                        <label>Store Name*</label>
                                        <input type='text' style={{ width: '100%', height: 35 }} id='war_store_name' onChange={(e) => this.handleChange(e)} />
                                        {/* {this.validator.message('Store Name', this.state.war_store_name, 'required|alpha_space')} */}
                                    </div>
                                    <div style={{padding:10}}>
                                        <label>City*</label>
                                        <input type='text' style={{ width: '100%', height: 35 }} id='war_city' onChange={(e) => this.handleChange(e)} />
                                        {/* {this.validator.message('city', this.state.war_city, 'required|alpha_space')} */}
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div style={{padding:10}}>
                                            <label>Purchase Date*</label>
                                            <input type='date' style={{ width: '100%', height: 35 }} id='war_purchase_date' onChange={(e) => this.handleChange(e)} />
                                            {/* {this.validator.message('Date', this.state.war_purchase_date, 'required')} */}
                                        </div></div>
                                        
                                        <div className='col-md-6' ><div style={{padding:10}}>
                                            <label>
                                                Upload the Invoice Copy*</label>
                                            <input id='war_invoice_copy' ref="upload" type="file" accept="image/*" onChange={(e) => this.handleChange(e)}
                                                //   onInput={(event)=> { 
                                                //        this.readFile(event) 
                                                //   }}
                                                onClick={(event) => {
                                                    event.target.value = null
                                                }}
                                            />
                                                {/* {this.validator.message('Invoice copy', this.state.war_invoice_copy, 'required|file')} */}
                                            </div>
                                            </div>
                                            </div>
                                            
                                        
                                    
                                </div>
                                <div className='col-md-12'><div style={{padding:10}}>
                                    
                                <button className='btn btn-solid' >SUBMIT</button></div></div>
                            
                            <div>{this.props.error}</div>
                            
                            </div>
                        </form>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    isAuth: state.user.isAuth,
    error: state.registrationDetails.error,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { submitFormData },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(regEnquery))